import React from 'react';
import { createMainController } from '../../../services/createMainController';
import NameListControllerV3 from './NameListControllerV3';

class NamesPagesController extends React.Component {

  render() {
    const { selectors } = this.props;
    const screenType = selectors.getScreenType();

    return <NameListControllerV3 screenType={screenType} />;
  }
}

export default createMainController(NamesPagesController);
